<template>
  <div class="mdl-grid">

      <div v-if='~isConnectedtoBC()'>
        Not connected to the Ethereum blockchain. Metamask is required.
        <a href='https://chrome.google.com/webstore/detail/metamask/nkbihfbeogaeaoehlefnkodbefgpgknn' target="_blank">Install Metamask extension for Google Chrome</a>
      </div>

      <div class="mdl-card mdl-cell mdl-cell--12-col mdl-shadow--2dp" v-if='isConnectedtoBC()'>

       <h3>Customers</h3>

      <button @click="getUsers" class="mdl-button mdl-js-button mdl-button--raised mdl-button--colored">
      See all customers
      </button>

      <div v-if="user_list && user_list.length">

        {{ user_list }}

        <br><br>

        //Table under construction//

         <table class="mdl-data-table mdl-js-data-table" style='width: 100%'>
          <thead>
            <tr>
              <th class="mdl-data-table__cell--non-numeric">Charge id</th>
              <th class="mdl-data-table__cell--non-numeric">Charger id</th>
              <th class="mdl-data-table__cell--non-numeric">Start date</th>
              <th class="mdl-data-table__cell--non-numeric">Duration (h)</th>
              <th class="mdl-data-table__cell--non-numeric">Mode</th>
              <th class="mdl-data-table__cell--non-numeric">Bonus (Units)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="mdl-data-table__cell--non-numeric">1</td>
              <td class="mdl-data-table__cell--non-numeric">123123</td>
              <th class="mdl-data-table__cell--non-numeric">2018-04-01</th>
              <td class="mdl-data-table__cell--non-numeric">6</td>
              <td class="mdl-data-table__cell--non-numeric">Fast</td>
              <td class="mdl-data-table__cell--non-numeric">0</td>
            </tr>
            <tr>
              <td class="mdl-data-table__cell--non-numeric">2</td>
              <td class="mdl-data-table__cell--non-numeric">123123</td>
              <th class="mdl-data-table__cell--non-numeric">2018-04-11</th>
              <td class="mdl-data-table__cell--non-numeric">12</td>
              <td class="mdl-data-table__cell--non-numeric">Flexible</td>
              <td class="mdl-data-table__cell--non-numeric">5</td>
            </tr>
          </tbody>
        </table>

      </div>

    </div>

  </div>
</template>

<script>
import ChargingLedger from '../utils/contractInstance.js'
import web3Instance from '../utils/web3Instance'

export default {

  name: 'UtilityPage',

  data () {
    return {

      user_list: [],

      table: {'columns': ['Charge id', 'Charger id', 'Start date', 'Duration (h)', 'Mode', 'Bonus (Units)']}
    }
  },

  mounted () {
    if (this.isConnectedtoBC()) {
      ChargingLedger.init()
    }
  },

  methods: {

    isConnectedtoBC () {
      try {
        var accounts = web3Instance.eth.accounts[0]
        } catch (err) {
        console.log(err)
      }
      return typeof accounts !== 'undefined' ? true : false
    },

    getUsers () {
      if (this.isConnectedtoBC()) {
        ChargingLedger.getUsersList().then(res => {
          res = [...new Set(res)]; // get unique values
          this.user_list = res
        })
      }
    }

  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/utility-page.vue